import Flickity from "flickity";

export default () => {
    const dom = document.querySelector('[data-hero-slide]');
    if (dom) {
        if (dom.children.length > 1) {
            const autoPlay = dom.getAttribute('data-autoplay') === '1' ? 3000 : false;
            const flickity = new Flickity(dom, {
                cellAlign: 'left',
                contain: true,
                prevNextButtons: true,
                pageDots: false,
                autoPlay: autoPlay,
                pauseAutoPlayOnHover: true
            });
        }
    }

}
